// Geteilte Länder-Erkennung für Mobile (client/) und Web (web/).
// Einzige Quelle für AT_POLYGON, die Länder-Bounding-Boxen und
// detectCountryFromCoordinates – damit Mobile und Web Grenzstädte
// (DE/AT/CH und Nachbarn) identisch klassifizieren.
//
// Die amtlich abgeleiteten Grenzpolygone (AT_POLYGON, CH_POLYGON +
// CH_BUESINGEN_HOLE/CH_CAMPIONE_HOLE, JUNGHOLZ_POLYGON) werden mit
// scripts/gen-country-polygon.mjs reproduzierbar aus geoBoundaries gbOpen
// ADM0 erzeugt (variable Douglas-Peucker-Toleranz, Enklaven-Löcher erhalten).
// Zum Aktualisieren/Hinzufügen eines Landes siehe den Header dieses Skripts,
// z. B. `node scripts/gen-country-polygon.mjs AUT --window=9.5,47.25,10.5,47.66`.

export interface CountryBoundingBox {
  iso: string;
  minLat: number;
  maxLat: number;
  minLon: number;
  maxLon: number;
}

export const COUNTRY_BOUNDING_BOXES: CountryBoundingBox[] = [
  { iso: "AT", minLat: 46.37, maxLat: 49.02, minLon: 9.53, maxLon: 17.16 },
  { iso: "BE", minLat: 49.49, maxLat: 51.51, minLon: 2.54, maxLon: 6.41 },
  { iso: "CH", minLat: 45.81, maxLat: 47.81, minLon: 5.96, maxLon: 10.49 },
  { iso: "DE", minLat: 47.27, maxLat: 55.06, minLon: 5.87, maxLon: 15.04 },
  { iso: "DK", minLat: 54.56, maxLat: 57.75, minLon: 8.07, maxLon: 15.19 },
  { iso: "EE", minLat: 57.52, maxLat: 59.68, minLon: 21.76, maxLon: 28.21 },
  { iso: "ES", minLat: 35.95, maxLat: 43.79, minLon: -9.30, maxLon: 4.33 },
  { iso: "FR", minLat: 41.33, maxLat: 51.12, minLon: -5.14, maxLon: 9.56 },
  { iso: "GR", minLat: 34.80, maxLat: 41.75, minLon: 19.37, maxLon: 29.65 },
  { iso: "HR", minLat: 42.39, maxLat: 46.55, minLon: 13.49, maxLon: 19.45 },
  { iso: "IT", minLat: 35.49, maxLat: 47.09, minLon: 6.63, maxLon: 18.52 },
  { iso: "LI", minLat: 47.05, maxLat: 47.27, minLon: 9.47, maxLon: 9.64 },
  { iso: "LU", minLat: 49.45, maxLat: 50.18, minLon: 5.73, maxLon: 6.53 },
  { iso: "LV", minLat: 55.67, maxLat: 58.08, minLon: 20.97, maxLon: 28.24 },
  { iso: "NL", minLat: 50.75, maxLat: 53.47, minLon: 3.36, maxLon: 7.21 },
  { iso: "NO", minLat: 57.96, maxLat: 71.19, minLon: 4.64, maxLon: 31.08 },
  { iso: "PL", minLat: 49.00, maxLat: 54.84, minLon: 14.12, maxLon: 24.15 },
  { iso: "PT", minLat: 36.96, maxLat: 42.15, minLon: -9.50, maxLon: -6.19 },
  { iso: "RO", minLat: 43.62, maxLat: 48.27, minLon: 20.26, maxLon: 29.76 },
  { iso: "SE", minLat: 55.34, maxLat: 69.06, minLon: 10.96, maxLon: 24.17 },
  { iso: "SI", minLat: 45.42, maxLat: 46.88, minLon: 13.38, maxLon: 16.61 },
  { iso: "BG", minLat: 41.23, maxLat: 44.22, minLon: 22.36, maxLon: 28.61 },
  { iso: "CY", minLat: 34.56, maxLat: 35.71, minLon: 32.27, maxLon: 34.60 },
  { iso: "CZ", minLat: 48.55, maxLat: 51.06, minLon: 12.09, maxLon: 18.86 },
  { iso: "FI", minLat: 59.70, maxLat: 70.09, minLon: 20.55, maxLon: 31.59 },
  { iso: "HU", minLat: 45.74, maxLat: 48.58, minLon: 16.45, maxLon: 22.90 },
  { iso: "IE", minLat: 51.42, maxLat: 55.39, minLon: -10.48, maxLon: -5.99 },
  { iso: "LT", minLat: 53.89, maxLat: 56.45, minLon: 20.95, maxLon: 26.84 },
  { iso: "MT", minLat: 35.78, maxLat: 36.10, minLon: 14.18, maxLon: 14.58 },
  { iso: "SK", minLat: 47.73, maxLat: 49.61, minLon: 16.83, maxLon: 22.57 },
  { iso: "AL", minLat: 39.60, maxLat: 42.70, minLon: 19.20, maxLon: 21.10 },
  { iso: "BA", minLat: 44.00, maxLat: 45.30, minLon: 15.70, maxLon: 19.60 },
  { iso: "BA", minLat: 42.50, maxLat: 44.00, minLon: 16.90, maxLon: 19.60 },
  { iso: "IS", minLat: 63.20, maxLat: 66.60, minLon: -24.60, maxLon: -13.40 },
  { iso: "XK", minLat: 42.20, maxLat: 43.27, minLon: 20.00, maxLon: 21.80 },
  { iso: "XK", minLat: 41.85, maxLat: 42.20, minLon: 20.00, maxLon: 20.80 },
  { iso: "MC", minLat: 43.71, maxLat: 43.76, minLon: 7.39, maxLon: 7.45 },
  { iso: "MK", minLat: 40.85, maxLat: 42.37, minLon: 20.45, maxLon: 23.04 },
  { iso: "ME", minLat: 41.85, maxLat: 43.56, minLon: 18.43, maxLon: 20.36 },
  { iso: "RS", minLat: 42.23, maxLat: 46.19, minLon: 18.83, maxLon: 23.01 },
  { iso: "UA", minLat: 44.39, maxLat: 52.38, minLon: 22.14, maxLon: 40.23 },
  { iso: "BY", minLat: 51.26, maxLat: 56.17, minLon: 23.18, maxLon: 32.74 },
  { iso: "RU", minLat: 41.19, maxLat: 77.72, minLon: 27.30, maxLon: 180.00 },
];

export interface BoundingBox {
  minLat: number;
  maxLat: number;
  minLon: number;
  maxLon: number;
}

// Liefert die grobe Bounding-Box eines Landes als Vereinigung aller
// COUNTRY_BOUNDING_BOXES-Einträge dieses ISO (manche Länder, z. B. BA/XK,
// haben mehrere Teil-Boxen). Einzige Quelle für die Radius-/Viewport-Abdeckung
// in geozoneCoverage.ts, damit Erkennung und Abdeckung dieselben Grenzen nutzen.
export function getCountryBoundingBox(iso: string): BoundingBox | undefined {
  const code = iso.toUpperCase();
  const boxes = COUNTRY_BOUNDING_BOXES.filter((b) => b.iso === code);
  if (boxes.length === 0) return undefined;
  return boxes.reduce<BoundingBox>(
    (acc, b) => ({
      minLat: Math.min(acc.minLat, b.minLat),
      maxLat: Math.max(acc.maxLat, b.maxLat),
      minLon: Math.min(acc.minLon, b.minLon),
      maxLon: Math.max(acc.maxLon, b.maxLon),
    }),
    { minLat: Infinity, maxLat: -Infinity, minLon: Infinity, maxLon: -Infinity },
  );
}

// Puffer (in Grad) um die Deutschland-Bounding-Box, der das "direkte Umland"
// abdeckt, in dem das DWD-ICON-D2-Modell (Grundlage von dipul UND BrightSky)
// noch zuverlässig ist. Bewusst konservativ: Grenzregionen wie Elsass,
// Benelux, Schweiz, Österreich, Tschechien und Westpolen bleiben damit auf
// DWD, während klar außerhalb liegende Orte (z. B. die französische
// Atlantik-/Kanalküste, ~4° westlich der DE-Grenze) als "Ausland" gelten.
const DWD_COVERAGE_BUFFER_DEG = 1.5;

// Liegt der Standort innerhalb der zuverlässigen DWD/ICON-D2-Abdeckung
// (Deutschland + direktes Umland)? dipul (ICON-D2) und BrightSky beruhen beide
// auf dem deutschen ICON-D2-Modell; am Modellrand und darüber hinaus werden die
// Werte unzuverlässig. Diese Funktion ist die einzige Quelle für die
// Wetterquellen-Reihenfolge (innen → dipul/BrightSky zuerst; außen → Open-Meteo
// zuerst, das im Ausland automatisch lokale Modelle wie AROME in FR nutzt).
export function isWithinDwdCoverage(lat: number, lon: number): boolean {
  const de = getCountryBoundingBox("DE");
  if (!de) return false;
  return (
    lat >= de.minLat - DWD_COVERAGE_BUFFER_DEG &&
    lat <= de.maxLat + DWD_COVERAGE_BUFFER_DEG &&
    lon >= de.minLon - DWD_COVERAGE_BUFFER_DEG &&
    lon <= de.maxLon + DWD_COVERAGE_BUFFER_DEG
  );
}

// CH ist nicht enthalten: Die Schweiz wird ausschließlich über das CH_POLYGON
// (REFINED_BOUNDARIES) erkannt und in der Box-Schleife übersprungen.
const PRIORITY_COUNTRIES = ["LU", "NL", "DE"];

// Grobes Grenzpolygon Tschechiens als [lon, lat]-Ring (im Uhrzeigersinn),
// genau genug, um die DE/AT/SK/PL-Überlappungen der Bounding-Boxen aufzulösen.
const CZ_POLYGON: number[][] = [
  [12.09, 50.25], [12.20, 50.32], [13.00, 50.50], [13.30, 50.62],
  [13.85, 50.78], [14.30, 51.06], [14.45, 51.02], [14.55, 51.00],
  [14.65, 50.92], [14.72, 50.84], [14.86, 50.83], [14.95, 50.93],
  [15.00, 51.00], [15.40, 50.80], [15.80, 50.74], [16.20, 50.66], [16.45, 50.40],
  [16.90, 50.45], [17.20, 50.30], [17.60, 50.22], [18.05, 49.98],
  [18.30, 49.92], [18.60, 49.72], [18.85, 49.51], [18.40, 49.32],
  [18.10, 49.10], [17.90, 48.92], [17.50, 48.82], [17.20, 48.88],
  [16.95, 48.62], [16.50, 48.73], [16.00, 48.76], [15.50, 48.78],
  [15.00, 48.78], [14.70, 48.58], [14.40, 48.58], [14.00, 48.62],
  [13.83, 48.70], [13.50, 48.95], [13.20, 49.12], [12.90, 49.34],
  [12.55, 49.70], [12.40, 49.98], [12.09, 50.25],
];

// Grobes Grenzpolygon Ostfrankreichs als [lon, lat]-Ring. Die groben DE-/CH-Boxen
// reichen weit nach Westen (DE bis lon 5.87, CH bis lon 5.96) und verschluckten
// sonst Elsass, Lothringen und die Franche-Comté als DE/CH. Wird VOR DE und CH
// geprüft, damit Ostfrankreich korrekt als FR erkannt wird (Ostkante folgt grob
// dem Rhein bzw. Jura, leicht nach Westen versetzt, um keine DE-/CH-Orte zu klauen).
const FR_EAST_POLYGON: number[][] = [
  [6.37, 49.46], // FR/DE/LU-Dreiländereck (Schengen)
  [6.85, 49.20], // Saarland-Grenze (französische Seite)
  [7.10, 49.12],
  [7.45, 49.05],
  [7.95, 49.05], // Wissembourg (Nordelsass)
  [8.13, 48.97], // Lauterbourg (NO-Elsass, Rhein)
  [8.0, 48.75],
  [7.8, 48.58], // Straßburg (Rhein)
  [7.66, 48.25],
  [7.56, 48.0], // Colmar (Rhein)
  [7.59, 47.59], // Basel-Dreiländereck
  [7.05, 47.43], // Jura
  [6.46, 47.05],
  [6.1, 46.7],
  // Um Genf herum nach Süden gezogen, damit die Haute-Savoie (Annemasse,
  // Saint-Julien-en-Genevois) und das Pays de Gex (Gex) korrekt als FR erkannt
  // werden. Genf selbst (CH) wird über GENEVA_HOLE wieder ausgespart, sonst
  // würde die Aussparung der Genfer Pocket fehlen.
  [6.10, 46.45], // Jura westlich von Nyon (Nyon bleibt östlich = CH)
  [6.13, 46.36], // Pays de Gex
  [6.20, 46.30],
  [6.28, 46.21], // östlich um Genf herum (Annemasse einschließen)
  [6.32, 46.14], // südlich von Genf/Annemasse
  [6.05, 46.10], // südlich von Saint-Julien zurück nach Westen
  [5.2, 46.2], // Westkante (tief in Frankreich)
  [4.8, 47.0],
  [4.8, 48.0],
  [5.1, 49.0],
  [5.6, 49.46],
  [6.37, 49.46],
];

// Aussparung (Loch) für den Kanton Genf innerhalb des FR_EAST_POLYGON. Genf ist
// von Frankreich nahezu eingeschlossen; das Ostpolygon reicht (bewusst) über die
// Genfer Pocket hinweg, um die umliegende Haute-Savoie/Pays de Gex zu erfassen.
// Dieses Loch holt den Schweizer Kern (Genf, Carouge, Versoix, Meyrin) wieder
// heraus, sodass er als CH/LSAS klassifiziert bleibt. Annäherung – die FR/CH-
// Grenze um Genf ist extrem verzahnt (CERN/Ferney/Meyrin); Ferney-Voltaire fällt
// daher mit in das Loch (bleibt CH), was hier bewusst in Kauf genommen wird.
const GENEVA_HOLE: number[][] = [
  [6.05, 46.16],
  [6.20, 46.16],
  [6.20, 46.31],
  [6.05, 46.31],
  [6.05, 46.16],
];

// Grenzpolygon Österreichs als [lon, lat]-Ring, abgeleitet aus der amtlichen
  // Landesgrenze (geoBoundaries gbOpen AUT/ADM0, OSM-basiert) und mit variabler
  // Douglas-Peucker-Toleranz vereinfacht: feine Auflösung (~60 m) im Allgäu/
  // Vorarlberg-Fenster (lon 9.5-10.5, lat 47.25-47.66), gröber (~1.3 km) im Rest.
  // Ersetzt die früheren von Hand eingefügten Kerben (Leiblachtal, Oberallgäu/
  // Oberstdorf, Talschluss/Balderschwang): die fein verzahnte DE/AT-Grenze rund um
  // Oberstdorf, Kleinwalsertal und Balderschwang folgt jetzt der echten Geometrie,
  // statt sie über Tradeoff-behaftete Stufen zu approximieren. Dadurch werden auch
  // die früher auf DE fallenden AT-Leiblachtal-Dörfer (Hörbranz/Hohenweiler/Möggers)
  // korrekt als AT erkannt, während die DE-Orte (Lindau, Sigmarszell, Oberstdorf,
  // Fischen, Sonthofen, Bad Hindelang, Balderschwang) außerhalb bleiben. Der
  // Österreich-Exklave Jungholz (von DE umschlossen) ist bewusst nicht enthalten.
export const AT_POLYGON: number[][] = [
  [10.45479, 47.55641], [10.43907, 47.52413], [10.4425, 47.51939], [10.44088, 47.5141],
  [10.43644, 47.51015], [10.43529, 47.50689], [10.43165, 47.50437], [10.43778, 47.49175],
  [10.44054, 47.49003], [10.44063, 47.48714], [10.44284, 47.4853], [10.4461, 47.48467],
  [10.45183, 47.48638], [10.45787, 47.48317], [10.46408, 47.48336], [10.46403, 47.48098],
  [10.46832, 47.47771], [10.46699, 47.47411], [10.47035, 47.46935], [10.46581, 47.46447],
  [10.46859, 47.45941], [10.46623, 47.45354], [10.47066, 47.44905], [10.47061, 47.44536],
  [10.4735, 47.44368], [10.47236, 47.44135], [10.47633, 47.43337], [10.47551, 47.43207],
  [10.4716, 47.43251], [10.45955, 47.42873], [10.45647, 47.4241], [10.45653, 47.41981],
  [10.44686, 47.41531], [10.43889, 47.41414], [10.4365, 47.4116], [10.43612, 47.40904],
  [10.43786, 47.40744], [10.43168, 47.40337], [10.43467, 47.40058], [10.43087, 47.39713],
  [10.42956, 47.39174], [10.4371, 47.38095], [10.43124, 47.38453], [10.42014, 47.38524],
  [10.417, 47.38065], [10.41375, 47.37918], [10.4065, 47.37772], [10.40086, 47.37818],
  [10.3951, 47.37621], [10.38908, 47.37023], [10.38954, 47.36784], [10.38601, 47.36238],
  [10.38759, 47.36039], [10.38678, 47.35714], [10.3806, 47.3532], [10.37784, 47.3531],
  [10.37122, 47.34591], [10.36849, 47.34529], [10.36527, 47.34209], [10.3572, 47.33761],
  [10.35698, 47.33398], [10.34615, 47.3226], [10.34571, 47.32046], [10.34896, 47.31784],
  [10.3468, 47.31578], [10.34102, 47.31486], [10.33969, 47.31112], [10.33066, 47.3054],
  [10.32474, 47.30444], [10.32411, 47.30622], [10.31691, 47.30735], [10.30175, 47.29928],
  [10.29597, 47.30049], [10.29392, 47.29882], [10.29265, 47.29506], [10.28523, 47.2918],
  [10.28198, 47.28832], [10.26612, 47.28869], [10.2672, 47.28737], [10.26645, 47.28577],
  [10.26183, 47.28485], [10.25986, 47.28202], [10.24877, 47.27969], [10.24589, 47.28097],
  [10.24571, 47.27961], [10.24259, 47.27873], [10.23854, 47.27251], [10.23266, 47.2711],
  [10.22274, 47.27642], [10.20793, 47.27589], [10.20154, 47.27748], [10.19532, 47.27371],
  [10.17434, 47.27083], [10.17282, 47.27471], [10.1755, 47.27635], [10.17238, 47.27966],
  [10.17623, 47.28264], [10.17517, 47.28984], [10.17748, 47.29106], [10.17991, 47.29661],
  [10.18202, 47.29668], [10.18513, 47.29452], [10.18997, 47.29454], [10.19588, 47.29781],
  [10.19939, 47.29811], [10.20438, 47.30303], [10.21107, 47.30688], [10.21206, 47.31132],
  [10.21628, 47.31165], [10.2112, 47.31805], [10.21142, 47.3196], [10.19982, 47.32705],
  [10.20773, 47.3329], [10.20792, 47.33555], [10.20455, 47.33735], [10.21752, 47.35064],
  [10.2173, 47.35495], [10.22493, 47.35942], [10.2262, 47.36281], [10.22929, 47.36399],
  [10.231, 47.36866], [10.23748, 47.37416], [10.232, 47.37956], [10.23657, 47.38245],
  [10.23008, 47.38854], [10.22739, 47.38952], [10.21891, 47.3831], [10.21291, 47.38099],
  [10.20861, 47.38356], [10.20017, 47.38396], [10.19543, 47.38994], [10.18757, 47.39058],
  [10.18215, 47.39302], [10.1817, 47.39046], [10.18303, 47.38867], [10.18161, 47.38785],
  [10.17685, 47.38586], [10.16971, 47.38643], [10.16989, 47.3719], [10.16618, 47.36947],
  [10.14199, 47.36778], [10.11964, 47.37621], [10.10014, 47.35536], [10.08315, 47.39442],
  [10.08658, 47.40005], [10.08197, 47.40199], [10.07997, 47.40494], [10.07803, 47.40462],
  [10.07325, 47.40672], [10.06943, 47.41076], [10.0724, 47.41187], [10.07254, 47.41384],
  [10.07449, 47.41534], [10.08575, 47.41512], [10.09405, 47.4175], [10.09599, 47.41849],
  [10.09617, 47.4228], [10.10589, 47.42932], [10.09414, 47.44111], [10.09335, 47.44798],
  [10.0953, 47.4505], [10.09189, 47.4596], [10.08984, 47.46102], [10.08807, 47.46054],
  [10.08801, 47.45937], [10.08501, 47.45966], [10.08088, 47.45597], [10.07027, 47.45656],
  [10.06866, 47.46149], [10.06498, 47.46424], [10.05376, 47.46746], [10.05196, 47.47163],
  [10.05483, 47.47479], [10.0544, 47.47654], [10.04558, 47.48547], [10.04746, 47.48687],
  [10.04503, 47.48825], [10.03772, 47.48979], [10.02314, 47.48468], [10.01667, 47.48544],
  [10.01051, 47.48241], [10.00106, 47.48272], [9.99536, 47.48687], [9.98765, 47.49908],
  [9.99599, 47.50339], [9.98988, 47.50636], [9.98485, 47.51159], [9.98147, 47.51111],
  [9.97838, 47.51415], [9.97194, 47.51614], [9.97128, 47.51814], [9.96553, 47.52152],
  [9.96531, 47.52362], [9.96805, 47.52527], [9.9676, 47.52754], [9.96868, 47.52862],
  [9.96753, 47.53096], [9.96556, 47.53074], [9.965, 47.53604], [9.96622, 47.53652],
  [9.96513, 47.53866], [9.9673, 47.53912], [9.96742, 47.54196], [9.97106, 47.54415],
  [9.97088, 47.54646], [9.96833, 47.54696], [9.96347, 47.54291], [9.95914, 47.54379],
  [9.96083, 47.54209], [9.95978, 47.53881], [9.96399, 47.53534], [9.95921, 47.53515],
  [9.94137, 47.53884], [9.93381, 47.53327], [9.92219, 47.53026], [9.91805, 47.53075],
  [9.91386, 47.53318], [9.9069, 47.54281], [9.89959, 47.54538], [9.88939, 47.54461],
  [9.88151, 47.54876], [9.87538, 47.54387], [9.87805, 47.54241], [9.87832, 47.53936],
  [9.87642, 47.53557], [9.87415, 47.5342], [9.87596, 47.53259], [9.87476, 47.52916],
  [9.86877, 47.53267], [9.85877, 47.53446], [9.85398, 47.54039], [9.84945, 47.54261],
  [9.8447, 47.54193], [9.83019, 47.54498], [9.8284, 47.54727], [9.81603, 47.54832],
  [9.81534, 47.55027], [9.81713, 47.55366], [9.82136, 47.55563], [9.82624, 47.56105],
  [9.82612, 47.56325], [9.82343, 47.56607], [9.82103, 47.57148], [9.82608, 47.57442],
  [9.82765, 47.57927], [9.82756, 47.5806], [9.82484, 47.58157], [9.82409, 47.58775],
  [9.81808, 47.58951], [9.81456, 47.58867], [9.8026, 47.59656], [9.79171, 47.59415],
  [9.78548, 47.59428], [9.78443, 47.5954], [9.78068, 47.59465], [9.77726, 47.59607],
  [9.76962, 47.58802], [9.76589, 47.58973], [9.76628, 47.586], [9.76368, 47.58707],
  [9.76095, 47.58419], [9.76222, 47.58158], [9.75662, 47.58035], [9.75624, 47.57296],
  [9.74829, 47.57114], [9.75233, 47.56813], [9.74769, 47.56503], [9.7472, 47.56124],
  [9.74367, 47.5594], [9.74701, 47.55771], [9.74734, 47.55632], [9.74197, 47.55551],
  [9.74089, 47.55241], [9.73548, 47.54732], [9.7371, 47.5367], [9.73593, 47.53483],
  [9.56206, 47.50519], [9.56154, 47.49922], [9.56322, 47.49542], [9.58204, 47.48376],
  [9.59619, 47.4634], [9.60104, 47.46222], [9.60357, 47.46286], [9.60531, 47.46471],
  [9.60687, 47.47045], [9.60928, 47.47116], [9.61202, 47.46989], [9.61718, 47.4626],
  [9.62256, 47.45811], [9.64527, 47.45637], [9.65883, 47.45323], [9.65968, 47.452],
  [9.65824, 47.44841], [9.64722, 47.44063], [9.64459, 47.43636], [9.65058, 47.4215],
  [9.65186, 47.40524], [9.65462, 47.40501], [9.66034, 47.39816], [9.6721, 47.39367],
  [9.67433, 47.39076], [9.67339, 47.38168], [9.66266, 47.37169], [9.65078, 47.36815],
  [9.63562, 47.36798], [9.62651, 47.36569], [9.6247, 47.36675], [9.60529, 47.35189],
  [9.59972, 47.34577], [9.58823, 47.31785], [9.58177, 47.31173], [9.56582, 47.30473],
  [9.55676, 47.29905], [9.55153, 47.28738], [9.54639, 47.28063], [9.53312, 47.27357],
  [9.53095, 47.27118], [9.53662, 47.26656], [9.54001, 47.26571], [9.53973, 47.26195],
  [9.55971, 47.25106], [9.56744, 47.24247], [9.55197, 47.22435], [9.5851, 47.20594],
  [9.56484, 47.17085], [9.62187, 47.15193], [9.63521, 47.12867], [9.62104, 47.11112],
  [9.63375, 47.08401], [9.60728, 47.06135], [9.68208, 47.06267], [9.83637, 47.0131],
  [9.87775, 47.02127], [9.89256, 46.99092], [9.87099, 46.96377], [9.87638, 46.93519],
  [10.01809, 46.90217], [10.10572, 46.8414], [10.23296, 46.86683], [10.24088, 46.93192],
  [10.31636, 46.92572], [10.30803, 46.94781], [10.34682, 46.99014], [10.38962, 47.00107],
  [10.4269, 46.97623], [10.42417, 46.95944], [10.48967, 46.93833], [10.46996, 46.85544],
  [10.5556, 46.84911], [10.54649, 46.83779], [10.6677, 46.87601], [10.76386, 46.82398],
  [10.73043, 46.78895], [10.78667, 46.79682], [10.88331, 46.76335], [11.02511, 46.76692],
  [11.03964, 46.80553], [11.08371, 46.82279], [11.07182, 46.85377], [11.102, 46.89016],
  [11.09633, 46.91242], [11.16454, 46.94045], [11.16484, 46.96633], [11.32076, 46.99289],
  [11.40604, 46.96533], [11.47922, 47.01149], [11.53899, 46.98459], [11.62768, 47.01381],
  [11.74751, 46.96937], [11.9172, 47.03368], [12.18652, 47.09265], [12.24131, 47.06967],
  [12.20527, 47.02738], [12.12188, 47.0075], [12.13246, 46.96281], [12.16922, 46.93779],
  [12.14435, 46.91427], [12.19089, 46.9066], [12.21596, 46.87448], [12.27426, 46.88487],
  [12.30732, 46.84171], [12.28348, 46.81541], [12.28448, 46.78339], [12.35799, 46.77543],
  [12.38462, 46.71679], [12.56184, 46.65295], [12.69123, 46.65741], [12.73199, 46.63473],
  [12.77654, 46.64713], [12.83188, 46.63173], [12.85332, 46.60504], [13.08621, 46.6022],
  [13.16926, 46.58932], [13.24045, 46.55211], [13.32124, 46.55164], [13.37292, 46.57968],
  [13.79518, 46.50573], [13.9128, 46.52151], [14.00726, 46.48174], [14.05152, 46.49357],
  [14.1223, 46.47698], [14.16399, 46.43397], [14.43039, 46.4474], [14.44345, 46.42342],
  [14.47964, 46.41385], [14.52259, 46.42761], [14.5649, 46.37265], [14.59681, 46.43717],
  [14.70025, 46.46404], [14.71563, 46.50031], [14.81949, 46.50974], [14.82392, 46.54627],
  [14.87129, 46.60759], [14.92045, 46.60244], [14.92377, 46.62124], [14.95657, 46.63309],
  [14.98028, 46.60176], [15.04195, 46.65213], [15.14628, 46.6602], [15.23685, 46.63974],
  [15.41505, 46.65589], [15.45784, 46.63932], [15.46308, 46.6156], [15.50326, 46.61425],
  [15.55083, 46.63883], [15.54468, 46.66964], [15.59612, 46.69036], [15.63099, 46.68039],
  [15.65098, 46.70611], [15.76949, 46.69936], [15.84073, 46.72273], [16.03914, 46.65647],
  [16.03088, 46.71194], [16.00465, 46.71749], [15.98584, 46.7523], [15.99208, 46.83317],
  [16.05945, 46.83901], [16.13403, 46.87596], [16.20099, 46.94215], [16.27753, 46.963],
  [16.29119, 47.01432], [16.30447, 46.99864], [16.51346, 47.00192], [16.44001, 47.03007],
  [16.52171, 47.05655], [16.47404, 47.07395], [16.46447, 47.09533], [16.53047, 47.12761],
  [16.51792, 47.14971], [16.45543, 47.14268], [16.45605, 47.18775], [16.42063, 47.19531],
  [16.44389, 47.23413], [16.43293, 47.25333], [16.46827, 47.25328], [16.49058, 47.28067],
  [16.46569, 47.33425], [16.43487, 47.35323], [16.46251, 47.3837], [16.44661, 47.40762],
  [16.4865, 47.4093], [16.49773, 47.38944], [16.51807, 47.411], [16.57692, 47.40676],
  [16.66321, 47.4561], [16.67167, 47.47466], [16.65353, 47.50074], [16.71573, 47.54034],
  [16.66575, 47.56668], [16.67434, 47.60537], [16.65327, 47.62333], [16.57371, 47.62028],
  [16.42271, 47.66573], [16.4485, 47.69675], [16.47589, 47.68169], [16.5423, 47.7126],
  [16.54917, 47.75199], [16.61045, 47.76082], [16.72216, 47.73577], [16.75024, 47.68186],
  [16.82955, 47.68316], [16.86814, 47.72207], [16.87638, 47.68877], [17.09434, 47.70867],
  [17.05223, 47.79442], [17.07572, 47.8087], [17.01121, 47.85879], [17.08646, 47.87488],
  [17.11397, 47.9278], [17.09218, 47.93484], [17.11827, 47.96135], [17.09595, 47.97132],
  [17.16207, 48.00711], [17.0687, 48.03189], [17.08907, 48.04614], [17.06953, 48.05586],
  [17.094, 48.10011], [17.05847, 48.14423], [17.02904, 48.14152], [16.97751, 48.17225],
  [16.9474, 48.23637], [16.95835, 48.26431], [16.90894, 48.28878], [16.89582, 48.31174],
  [16.90983, 48.32669], [16.84398, 48.3529], [16.83459, 48.3819], [16.85172, 48.38369],
  [16.8649, 48.41986], [16.85129, 48.44967], [16.95524, 48.54378], [16.90334, 48.71852],
  [16.80164, 48.70645], [16.72604, 48.73859], [16.68387, 48.72834], [16.66503, 48.78157],
  [16.59486, 48.78323], [16.542, 48.81485], [16.5199, 48.79881], [16.46167, 48.8096],
  [16.43626, 48.76619], [16.37924, 48.72903], [16.34406, 48.74619], [16.33112, 48.73181],
  [16.09538, 48.74722], [15.99556, 48.77992], [15.95082, 48.80583], [15.95957, 48.82365],
  [15.89442, 48.83523], [15.89884, 48.84895], [15.84392, 48.8602], [15.84272, 48.87772],
  [15.7807, 48.87548], [15.75483, 48.85277], [15.69085, 48.85627], [15.61358, 48.89886],
  [15.51453, 48.91473], [15.46963, 48.95243], [15.27999, 48.99528], [15.26273, 48.95427],
  [15.16134, 48.94231], [15.15738, 48.99392], [15.02163, 49.02117], [14.99152, 49.01029],
  [14.9989, 48.9926], [14.97727, 48.97164], [14.99399, 48.90434], [14.97401, 48.87528],
  [14.98559, 48.84301], [14.95432, 48.7904], [14.98056, 48.77287], [14.95685, 48.7587],
  [14.8097, 48.77942], [14.80917, 48.7345], [14.72799, 48.68768], [14.71336, 48.6507],
  [14.72215, 48.60298], [14.70254, 48.58329], [14.66446, 48.58256], [14.61147, 48.62871],
  [14.56305, 48.60394], [14.50427, 48.61798], [14.47085, 48.64911], [14.44474, 48.64404],
  [14.45703, 48.62575], [14.43239, 48.58974], [14.38721, 48.59328], [14.38905, 48.57249],
  [14.35863, 48.57526], [14.33419, 48.55242], [14.27249, 48.58199], [14.06789, 48.59548],
  [14.04307, 48.61349], [14.04906, 48.62799], [14.01148, 48.64028], [14.05445, 48.65356],
  [14.0604, 48.67446], [13.84413, 48.77322], [13.79578, 48.71573], [13.83833, 48.70119],
  [13.81439, 48.69248], [13.82668, 48.61921], [13.80181, 48.57423], [13.77089, 48.5542],
  [13.75494, 48.5642], [13.73139, 48.51539], [13.50983, 48.59126], [13.47621, 48.5567],
  [13.43847, 48.55778], [13.459, 48.51246], [13.42788, 48.45751], [13.44004, 48.43129],
  [13.41274, 48.37589], [13.33021, 48.3239], [13.25742, 48.29426], [13.18007, 48.29539],
  [13.02301, 48.25864], [12.95748, 48.21013], [12.87078, 48.20193], [12.78718, 48.12404],
  [12.75964, 48.1276], [12.76018, 48.07577], [12.85091, 48.01681], [12.87462, 47.96451],
  [12.93888, 47.94387], [13.00421, 47.85024], [12.90595, 47.72399], [12.97451, 47.7077],
  [13.01896, 47.72344], [13.08146, 47.68758], [13.09964, 47.63571], [13.06331, 47.602],
  [13.07135, 47.58752], [13.04436, 47.5839], [13.05822, 47.56269], [13.03164, 47.5331],
  [13.04834, 47.49269], [13.00436, 47.46392], [12.79498, 47.55756], [12.77981, 47.57966],
  [12.82517, 47.61265], [12.75924, 47.65211], [12.78184, 47.67437], [12.608, 47.67429],
  [12.57567, 47.63287], [12.4998, 47.62566], [12.44139, 47.67446], [12.4407, 47.69579],
  [12.25585, 47.68003], [12.24186, 47.69495], [12.25763, 47.74362], [12.16301, 47.70175],
  [12.20455, 47.60733], [12.02247, 47.61165], [12.00909, 47.62575], [11.8555, 47.60293],
  [11.84475, 47.58174], [11.63671, 47.59514], [11.60626, 47.58163], [11.57291, 47.51508],
  [11.44263, 47.51853], [11.3843, 47.47296], [11.42165, 47.44516], [11.33899, 47.45047],
  [11.27037, 47.39814], [11.2254, 47.39582], [11.25386, 47.42881], [11.20743, 47.43451],
  [11.11527, 47.39603], [10.97228, 47.40013], [10.98403, 47.4306], [10.92995, 47.47082],
  [10.9376, 47.48173], [10.87046, 47.48384], [10.87241, 47.50097], [10.91839, 47.51421],
  [10.8907, 47.53791], [10.7779, 47.51451], [10.69138, 47.55938], [10.59833, 47.57035],
  [10.57147, 47.53407], [10.48927, 47.54101], [10.4727, 47.55172], [10.46085, 47.55323],
  [10.45479, 47.55641],
];

// Österreich-Exklave Jungholz als [lon, lat]-Ring (geoBoundaries gbOpen AUT/ADM0,
// zweiter MultiPolygon-Ring, Douglas-Peucker ~60 m vereinfacht). Jungholz ist ein
// österreichisches Dorf, das vollständig von Deutschland umschlossen ist und nur an
// einem einzigen Bergpunkt (Sorgschrofen, ~[10.45479, 47.55641]) mit Österreich
// zusammenhängt. Das Haupt-AT_POLYGON schließt die Exklave bewusst aus; dieses
// separate Polygon wird VOR dem Haupt-Ring geprüft, damit ein Pilot in Jungholz als
// AT (nicht DE) erkannt wird, ohne den Rest der Grenze zu beeinflussen.
export const JUNGHOLZ_POLYGON: number[][] = [
  [10.45479, 47.55641], [10.46758, 47.56838], [10.47112, 47.57074], [10.47352, 47.5707],
  [10.4709, 47.57774], [10.47108, 47.58034], [10.4735, 47.57996], [10.4794, 47.58125],
  [10.48237, 47.5851], [10.47302, 47.58526], [10.47275, 47.58754], [10.47003, 47.58774],
  [10.46259, 47.58632], [10.45976, 47.58427], [10.45617, 47.58327], [10.44953, 47.58468],
  [10.44116, 47.5841], [10.43738, 47.58481], [10.43526, 47.58421], [10.4333, 47.58219],
  [10.43575, 47.58002], [10.42937, 47.57821], [10.43393, 47.57338], [10.43226, 47.57305],
  [10.43348, 47.57018], [10.43526, 47.57009], [10.43664, 47.56831], [10.44557, 47.56785],
  [10.45058, 47.55596], [10.45165, 47.55528], [10.45479, 47.55641],
];

// Grenzpolygon der Schweiz als [lon, lat]-Ring, abgeleitet aus der amtlichen
// Landesgrenze (geoBoundaries gbOpen CHE/ADM0, Quelle swisstopo) und mit
// variabler Douglas-Peucker-Toleranz vereinfacht: feine Auflösung (~60 m) entlang
// der DE/CH-Grenze (Hochrhein/Bodensee) und der CH/LI-Grenze, fein (~100 m) am
// südlichen Tessiner Zipfel (Mendrisiotto/Chiasso – sonst verschluckt die grobe
// Vereinfachung die jagged CH/IT-Grenze und Chiasso fällt aus dem Polygon), gröber
// (~2 km) im übrigen Alpenraum. Ersetzt die frühere grobe CH-Bounding-Box (bis lat 47.81, lon 10.49),
// die deutsche Bodensee-/Allgäu-Orte verschluckte und zwei manuelle DE-Kompensations-
// klauseln nötig machte. Mit der echten Geometrie werden Schweizer Rheintal-Orte
// (Basel, Schaffhausen, Kreuzlingen, St. Gallen) korrekt als CH erkannt, während die
// deutschen Ufer-/Allgäu-Orte (Lindau, Konstanz, Friedrichshafen, Singen, Lörrach)
// außerhalb bleiben. Die Löcher CH_BUESINGEN_HOLE (deutsche Enklave Büsingen) und
// CH_CAMPIONE_HOLE (italienische Enklave Campione d'Italia) sparen die Enklaven aus.
const CH_POLYGON: number[][] = [
  [8.56888, 47.80723], [8.56803, 47.80845], [8.56381, 47.80539], [8.56252, 47.80231],
  [8.562, 47.7926], [8.57496, 47.78962], [8.57446, 47.78689], [8.57733, 47.78167],
  [8.56639, 47.77791], [8.56289, 47.77789], [8.56331, 47.78057], [8.55292, 47.78463],
  [8.53565, 47.77978], [8.53246, 47.77803], [8.52648, 47.77801], [8.52272, 47.77496],
  [8.5202, 47.77052], [8.51031, 47.7762], [8.50867, 47.77423], [8.50231, 47.77364],
  [8.49537, 47.77074], [8.49099, 47.77168], [8.48902, 47.77321], [8.47315, 47.76407],
  [8.46913, 47.75927], [8.46652, 47.75361], [8.45678, 47.74957], [8.45595, 47.74806],
  [8.45648, 47.74564], [8.45532, 47.74421], [8.45585, 47.7428], [8.45277, 47.74158],
  [8.45011, 47.73895], [8.45036, 47.73603], [8.45263, 47.73085], [8.45712, 47.73016],
  [8.45461, 47.72711], [8.45425, 47.72352], [8.45534, 47.72307], [8.45494, 47.72245],
  [8.44534, 47.72307], [8.44019, 47.71974], [8.44191, 47.7186], [8.44167, 47.71789],
  [8.43647, 47.7182], [8.4261, 47.71129], [8.42534, 47.71173], [8.42015, 47.70951],
  [8.41712, 47.71018], [8.40464, 47.69803], [8.40641, 47.69557], [8.41198, 47.69441],
  [8.4182, 47.68819], [8.42079, 47.68387], [8.41836, 47.68278], [8.4162, 47.67979],
  [8.40853, 47.67857], [8.4056, 47.67418], [8.41221, 47.66633], [8.42365, 47.66686],
  [8.43199, 47.66213], [8.43662, 47.65738], [8.43863, 47.65738], [8.44512, 47.65386],
  [8.45367, 47.65477], [8.45729, 47.65274], [8.46597, 47.65725], [8.46714, 47.65603],
  [8.46373, 47.64846], [8.46711, 47.64154], [8.47, 47.63932], [8.4735, 47.6384],
  [8.47414, 47.6393], [8.47805, 47.63977], [8.47192, 47.64115], [8.47104, 47.64235],
  [8.47772, 47.64466], [8.47742, 47.64597], [8.47391, 47.64697], [8.47308, 47.64827],
  [8.47372, 47.64969], [8.47642, 47.6501], [8.48039, 47.64924], [8.4822, 47.64744],
  [8.48147, 47.64561], [8.4828, 47.6441], [8.48519, 47.64392], [8.48742, 47.64507],
  [8.4896, 47.64253], [8.49169, 47.64295], [8.4924, 47.64209], [8.49435, 47.64207],
  [8.49333, 47.64695], [8.50019, 47.64621], [8.49955, 47.64725], [8.50902, 47.64669],
  [8.51332, 47.6475], [8.52297, 47.64485], [8.53179, 47.64575], [8.53462, 47.64969],
  [8.52913, 47.65501], [8.53003, 47.65704], [8.52802, 47.65802], [8.52694, 47.66045],
  [8.53345, 47.66312], [8.53447, 47.65936], [8.54164, 47.65679], [8.53887, 47.66277],
  [8.53996, 47.66508], [8.55441, 47.66941], [8.56089, 47.67032], [8.56372, 47.67004],
  [8.56344, 47.66809], [8.56475, 47.66526], [8.56616, 47.6657], [8.56917, 47.66419],
  [8.57091, 47.66487], [8.57767, 47.66152], [8.58727, 47.66625], [8.59138, 47.66752],
  [8.59331, 47.66679], [8.59798, 47.67272], [8.60661, 47.67215], [8.60583, 47.66942],
  [8.60809, 47.66415], [8.61283, 47.6608], [8.61454, 47.66156], [8.61959, 47.65924],
  [8.62729, 47.65407], [8.62886, 47.65199], [8.62871, 47.64906], [8.62335, 47.64092],
  [8.61556, 47.63771], [8.60703, 47.63707], [8.60338, 47.63883], [8.60417, 47.64127],
  [8.61079, 47.64187], [8.61396, 47.64437], [8.6132, 47.64891], [8.60851, 47.6522],
  [8.60511, 47.65196], [8.60199, 47.64626], [8.59604, 47.64328], [8.59531, 47.64066],
  [8.5971, 47.63005], [8.59964, 47.62378], [8.60481, 47.61702], [8.605, 47.6135],
  [8.60305, 47.61067], [8.59573, 47.60561], [8.59274, 47.60616], [8.59018, 47.60121],
  [8.58778, 47.60174], [8.58432, 47.59979], [8.58258, 47.59614], [8.57687, 47.59682],
  [8.57487, 47.59551], [8.57113, 47.5982], [8.56664, 47.59715], [8.56222, 47.60029],
  [8.56165, 47.6013], [8.56642, 47.60609], [8.56639, 47.60986], [8.57277, 47.61086],
  [8.57452, 47.61197], [8.57123, 47.61248], [8.57154, 47.61396], [8.57028, 47.61423],
  [8.57066, 47.61526], [8.56934, 47.6172], [8.56293, 47.6167], [8.56131, 47.62081],
  [8.55989, 47.62113], [8.5579, 47.62445], [8.54433, 47.62515], [8.54293, 47.62705],
  [8.5387, 47.62629], [8.53895, 47.63096], [8.52564, 47.63171], [8.52077, 47.63432],
  [8.51566, 47.63379], [8.51654, 47.63205], [8.51491, 47.63021], [8.51587, 47.6285],
  [8.51281, 47.62531], [8.51507, 47.62456], [8.51514, 47.62338], [8.50744, 47.62382],
  [8.50896, 47.61856], [8.50722, 47.61826], [8.50835, 47.61752], [8.5031, 47.61727],
  [8.49333, 47.61444], [8.48847, 47.61505], [8.48462, 47.61474], [8.4833, 47.61367],
  [8.47921, 47.61521], [8.47799, 47.61356], [8.47866, 47.61333], [8.47814, 47.61098],
  [8.47529, 47.60794], [8.47032, 47.60855], [8.47139, 47.60659], [8.47005, 47.60543],
  [8.46815, 47.60539], [8.46855, 47.60386], [8.46365, 47.60226], [8.45669, 47.60232],
  [8.45704, 47.59738], [8.45926, 47.59608], [8.46124, 47.59267], [8.46054, 47.58838],
  [8.46482, 47.58801], [8.46687, 47.58425], [8.48104, 47.5852], [8.48328, 47.58692],
  [8.48871, 47.58783], [8.49475, 47.58103], [8.48531, 47.57716], [8.47667, 47.57781],
  [8.46406, 47.57217], [8.45623, 47.57244], [8.43838, 47.56726], [8.43045, 47.56664],
  [8.41486, 47.57108], [8.40428, 47.5757], [8.3972, 47.57716], [8.38999, 47.57348],
  [8.38545, 47.56716], [8.38252, 47.56572], [8.37317, 47.56812], [8.35874, 47.57013],
  [8.32966, 47.57095], [8.32189, 47.57405], [8.31086, 47.58336], [8.30304, 47.58579],
  [8.29776, 47.58924], [8.29585, 47.5919], [8.29533, 47.59456], [8.29774, 47.60519],
  [8.29246, 47.60889], [8.28628, 47.61087], [8.27926, 47.61171], [8.2649, 47.60931],
  [8.26284, 47.61045], [8.26062, 47.61463], [8.25729, 47.61529], [8.2449, 47.61249],
  [8.23792, 47.61269], [8.23058, 47.60639], [8.2265, 47.60504], [8.22404, 47.60699],
  [8.22223, 47.61371], [8.21973, 47.61759], [8.21317, 47.62029], [8.20561, 47.62105],
  [8.19695, 47.61842], [8.19275, 47.61516], [8.1854, 47.60554], [8.17519, 47.60196],
  [8.16494, 47.59419], [8.16031, 47.59358], [8.1527, 47.59584], [8.14914, 47.59583],
  [8.1382, 47.59012], [8.13754, 47.58881], [8.13805, 47.5855], [8.13589, 47.58373],
  [8.11588, 47.5839], [8.10981, 47.58255], [8.10315, 47.57632], [8.10181, 47.56735],
  [8.0995, 47.56283], [8.09658, 47.56059], [8.08931, 47.55771], [8.08134, 47.55806],
  [8.07184, 47.56347], [8.06727, 47.56449], [8.06328, 47.56327], [8.05938, 47.56354],
  [8.05738, 47.56133], [8.04732, 47.55571], [8.03977, 47.55349], [8.02135, 47.55035],
  [8.01494, 47.55121], [8.00718, 47.55498], [8.00071, 47.55632], [7.97657, 47.55529],
  [7.95989, 47.55813], [7.95265, 47.55474], [7.94932, 47.54623], [7.9469, 47.54425],
  [7.94413, 47.54389], [7.93253, 47.54692], [7.91855, 47.54736], [7.91196, 47.55078],
  [7.90927, 47.55396], [7.90723, 47.55986], [7.90784, 47.56203], [7.91144, 47.5666],
  [7.91062, 47.57138], [7.90309, 47.58082], [7.89207, 47.58743], [7.8847, 47.58883],
  [7.86812, 47.58874], [7.86053, 47.58748], [7.8475, 47.58265], [7.84262, 47.58214],
  [7.83781, 47.58282], [7.8322, 47.5868], [7.82284, 47.58797], [7.81867, 47.58676],
  [7.81533, 47.58157], [7.81147, 47.56919], [7.80138, 47.56367], [7.79569, 47.55738],
  [7.78245, 47.55311], [7.7735, 47.55235], [7.75842, 47.54847], [7.75223, 47.54481],
  [7.71891, 47.54164], [7.69796, 47.53323], [7.6925, 47.5324], [7.67896, 47.53292],
  [7.6687, 47.53557], [7.66457, 47.5388], [7.66109, 47.54505], [7.64995, 47.54786],
  [7.64072, 47.55751], [7.63394, 47.5612], [7.63613, 47.56392], [7.64127, 47.56127],
  [7.64828, 47.55994], [7.65616, 47.56228], [7.65876, 47.56448], [7.66423, 47.5654],
  [7.67071, 47.56582], [7.67237, 47.56544], [7.67246, 47.56373], [7.67732, 47.56375],
  [7.67729, 47.56494], [7.67515, 47.56543], [7.67911, 47.5695], [7.68351, 47.57126],
  [7.68343, 47.56843], [7.68593, 47.56562], [7.68966, 47.5714], [7.68892, 47.57243],
  [7.68368, 47.57391], [7.68386, 47.57666], [7.68191, 47.57746], [7.68086, 47.58269],
  [7.67208, 47.58524], [7.67175, 47.58728], [7.67959, 47.59225], [7.68365, 47.59603],
  [7.69016, 47.59758], [7.6938, 47.60078], [7.68932, 47.59885], [7.68302, 47.5985],
  [7.67679, 47.59432], [7.67518, 47.59199], [7.66734, 47.59195], [7.64568, 47.59696],
  [7.64179, 47.5942], [7.64325, 47.59135], [7.63964, 47.59037], [7.62803, 47.58137],
  [7.61914, 47.57687], [7.61321, 47.57816], [7.60489, 47.57788], [7.60534, 47.57989],
  [7.60406, 47.58134], [7.60482, 47.58493], [7.59847, 47.58764], [7.58904, 47.5899],
  [7.58572, 47.58409], [7.5844, 47.57858], [7.58466, 47.57552], [7.56649, 47.57767],
  [7.56544, 47.57622], [7.55689, 47.57247], [7.55646, 47.57139], [7.55933, 47.56939],
  [7.5573, 47.56503], [7.54686, 47.5615], [7.54037, 47.55728], [7.53949, 47.558],
  [7.53653, 47.55546], [7.52732, 47.55278], [7.51676, 47.54541], [7.51098, 47.54451],
  [7.50935, 47.54584], [7.50546, 47.54439], [7.49918, 47.54012], [7.49804, 47.53616],
  [7.50144, 47.53218], [7.50052, 47.53014], [7.5023, 47.52841], [7.5051, 47.52903],
  [7.50768, 47.52812], [7.51076, 47.52899], [7.51936, 47.53472], [7.5244, 47.53187],
  [7.52678, 47.53288], [7.52976, 47.53068], [7.53123, 47.52816], [7.52759, 47.52176],
  [7.52346, 47.51868], [7.52373, 47.51534], [7.52219, 47.5142], [7.52074, 47.51572],
  [7.51908, 47.51482], [7.51746, 47.51729], [7.5113, 47.51703], [7.50546, 47.51466],
  [7.50228, 47.51491], [7.49976, 47.52058], [7.49788, 47.52125], [7.49909, 47.51628],
  [7.50589, 47.51135], [7.50792, 47.51082], [7.51031, 47.50599], [7.51045, 47.50263],
  [7.50876, 47.50235], [7.51107, 47.49703], [7.50114, 47.49352], [7.50245, 47.49077],
  [7.49995, 47.49102], [7.4981, 47.48894], [7.4938, 47.48842], [7.49162, 47.48467],
  [7.48728, 47.48202], [7.47708, 47.48008], [7.47201, 47.48039], [7.46609, 47.48476],
  [7.46239, 47.48906], [7.45641, 47.48851], [7.45083, 47.49032], [7.4461, 47.49386],
  [7.44109, 47.49511], [7.43499, 47.49811], [7.43315, 47.49717], [7.42975, 47.49358],
  [7.429, 47.49108], [7.42232, 47.48392], [7.42082, 47.48037], [7.4294, 47.48295],
  [7.43213, 47.48101], [7.43622, 47.48066], [7.44161, 47.4781], [7.44362, 47.47852],
  [7.44841, 47.47379], [7.45018, 47.47533], [7.45574, 47.47338], [7.45583, 47.47071],
  [7.45021, 47.46752], [7.44522, 47.46238], [7.44577, 47.46198], [7.43263, 47.45925],
  [7.43003, 47.4595], [7.42776, 47.4573], [7.4288, 47.45388], [7.42242, 47.45072],
  [7.42446, 47.44992], [7.42056, 47.44557], [7.41521, 47.44271], [7.40321, 47.43868],
  [7.40305, 47.43549], [7.39392, 47.43517], [7.38559, 47.43186], [7.3821, 47.43305],
  [7.38115, 47.43195], [7.36825, 47.43436], [7.3548, 47.43393], [7.34484, 47.43614],
  [7.34477, 47.43755], [7.34113, 47.43885], [7.339, 47.44112], [7.33031, 47.44178],
  [7.32345, 47.43867], [7.3126, 47.43799], [7.30692, 47.43899], [7.3024, 47.43865],
  [7.30053, 47.43649], [7.29576, 47.43567], [7.29266, 47.43336], [7.28693, 47.43516],
  [7.28191, 47.43481], [7.28005, 47.43285], [7.27792, 47.43248], [7.2697, 47.427],
  [7.25496, 47.42439], [7.25039, 47.42298], [7.24941, 47.42142], [7.24655, 47.42034],
  [7.24541, 47.42105], [7.24631, 47.42218], [7.24578, 47.42653], [7.24381, 47.42782],
  [7.23903, 47.42852], [7.23754, 47.43058], [7.23888, 47.43329], [7.23345, 47.43862],
  [7.22903, 47.43989], [7.22292, 47.43982], [7.20669, 47.43485], [7.2056, 47.43558],
  [7.1958, 47.43542], [7.19511, 47.43741], [7.19252, 47.43901], [7.17561, 47.44295],
  [7.1702, 47.44298], [7.17833, 47.45855], [7.17724, 47.45945], [7.17891, 47.4608],
  [7.1791, 47.46549], [7.1775, 47.46805], [7.18466, 47.47723], [7.18692, 47.48251],
  [7.19037, 47.48616], [7.19086, 47.48851], [7.20299, 47.4914], [7.20115, 47.49287],
  [7.20097, 47.49428], [7.1731, 47.48976], [7.16228, 47.49], [7.15693, 47.49213],
  [7.15042, 47.49732], [7.13919, 47.50179], [7.128, 47.50388], [7.11252, 47.49511],
  [7.10004, 47.49432], [7.09423, 47.49544], [7.08135, 47.48972], [7.07485, 47.48819],
  [7.07255, 47.48974], [7.07207, 47.49238], [7.06076, 47.49539], [7.05243, 47.49511],
  [7.04453, 47.49845], [7.03694, 47.49751], [7.03665, 47.4992], [7.02765, 47.50132],
  [7.02493, 47.50429], [7.02151, 47.50447], [7.00038, 47.49972], [6.99941, 47.49862],
  [6.98603, 47.49334], [6.98297, 47.49455], [6.98264, 47.49366], [6.98643, 47.49214],
  [6.98575, 47.49165], [6.98865, 47.4869], [6.98859, 47.48102], [6.98644, 47.47633],
  [6.9883, 47.4731], [6.99299, 47.47113], [6.99083, 47.46761], [6.9917, 47.4664],
  [7.00048, 47.4672], [6.99979, 47.46497], [7.00129, 47.46192], [6.99789, 47.45985],
  [6.99754, 47.45643], [7.00144, 47.45598], [7.00218, 47.45416], [6.99588, 47.44965],
  [6.99019, 47.44798], [6.98407, 47.44819], [6.98098, 47.44923], [6.97029, 47.44711],
  [6.96628, 47.43765], [6.96371, 47.43579], [6.95757, 47.43381], [6.95496, 47.43527],
  [6.9403, 47.43332], [6.94155, 47.4157], [6.94086, 47.41159], [6.93843, 47.40608],
  [6.92063, 47.40507], [6.91971, 47.40663], [6.91325, 47.40458], [6.91777, 47.40318],
  [6.91555, 47.39914], [6.91549, 47.39716], [6.90931, 47.3961], [6.91158, 47.39377],
  [6.91104, 47.39161], [6.91387, 47.38932], [6.91351, 47.38809], [6.91207, 47.38619],
  [6.90523, 47.38337], [6.90512, 47.38252], [6.89509, 47.38171], [6.89581, 47.3799],
  [6.8885, 47.3765], [6.8836, 47.37287], [6.88492, 47.36743], [6.88253, 47.3612],
  [6.87936, 47.35778], [6.87929, 47.35258], [6.88696, 47.35329], [6.89156, 47.35586],
  [6.89474, 47.35654], [6.89565, 47.35867], [6.89964, 47.35772], [6.90277, 47.35957],
  [6.91534, 47.35762], [6.91962, 47.35531], [6.92408, 47.35518], [6.93311, 47.35845],
  [6.93512, 47.35755], [6.94278, 47.35767], [6.94639, 47.35928], [6.95209, 47.35998],
  [6.95238, 47.35905], [6.96102, 47.3593], [6.96416, 47.3603], [6.9659, 47.35924],
  [6.97057, 47.36102], [6.97459, 47.36014], [6.98428, 47.36367], [6.99638, 47.36361],
  [7.0074, 47.36812], [7.01217, 47.37289], [7.01311, 47.37143], [7.01557, 47.37292],
  [7.01818, 47.37263], [7.01829, 47.37136], [7.02014, 47.37034], [7.02939, 47.36912],
  [7.03408, 47.36967], [7.03484, 47.36335], [7.04313, 47.36427], [7.04994, 47.36143],
  [7.05282, 47.35155], [7.05052, 47.34994], [7.04988, 47.34771], [7.05544, 47.34739],
  [7.06239, 47.34411], [7.0598, 47.33974], [7.05511, 47.33872], [7.05436, 47.33827],
  [7.05522, 47.33759], [7.05293, 47.33669], [7.05366, 47.33578], [7.05301, 47.3351],
  [7.05696, 47.3344], [6.94102, 47.28669], [6.95567, 47.2431], [6.70273, 47.08214],
  [6.71917, 47.05118], [6.43269, 46.92868], [6.46462, 46.89036], [6.43104, 46.81236],
  [6.45224, 46.77422], [6.11047, 46.57644], [6.15666, 46.5453], [6.07279, 46.46544],
  [6.06386, 46.41639], [6.16993, 46.36608], [6.10239, 46.28494], [6.12079, 46.24802],
  [5.97336, 46.21372], [5.99491, 46.18184], [5.95685, 46.12876], [6.13644, 46.14159],
  [6.29468, 46.22515], [6.30975, 46.25623], [6.26015, 46.25168], [6.21955, 46.31188],
  [6.3352, 46.40372], [6.51912, 46.45637], [6.68187, 46.45433], [6.82107, 46.42716],
  [6.77102, 46.35377], [6.86494, 46.2802], [6.80355, 46.20461], [6.79654, 46.13868],
  [6.89993, 46.12388], [6.87173, 46.05115], [6.93732, 46.06428], [7.10114, 45.85928],
  [7.19649, 45.86026], [7.29443, 45.92182], [7.38633, 45.89715], [7.49918, 45.96242],
  [7.54272, 45.95696], [7.55013, 45.98656], [7.66427, 45.97566], [7.72048, 45.92379],
  [7.86408, 45.91675], [7.90868, 45.99694], [8.01241, 46.01197], [8.03476, 46.10084],
  [8.15534, 46.14763], [8.16551, 46.18223], [8.08593, 46.26662], [8.3129, 46.37707],
  [8.28893, 46.40811], [8.30749, 46.42585], [8.44572, 46.46372], [8.47117, 46.39592],
  [8.42774, 46.2983], [8.44453, 46.24888], [8.53244, 46.21828], [8.61184, 46.12166],
  [8.71399, 46.09723], [8.74234, 46.12231], [8.85211, 46.07564],
  // Tessiner Südzipfel (Mendrisiotto/Chiasso) fein (~100 m), siehe Kommentar oben.
  [8.78588, 45.98908], [8.79083, 45.98859], [8.79242, 45.99189], [8.79577, 45.99207],
  [8.81022, 45.98982], [8.81383, 45.99097], [8.82014, 45.98741], [8.83132, 45.98802],
  [8.8344, 45.98508], [8.83923, 45.98422], [8.8401, 45.98166], [8.8427, 45.98147],
  [8.84343, 45.97761], [8.84963, 45.97287], [8.86069, 45.96611], [8.86473, 45.96546],
  [8.8683, 45.96062], [8.87821, 45.95664], [8.89366, 45.95898], [8.89665, 45.95475],
  [8.8986, 45.94626], [8.8935, 45.93739], [8.89331, 45.93118], [8.90745, 45.91779],
  [8.91429, 45.9178], [8.92413, 45.90564], [8.92494, 45.90086], [8.92153, 45.89577],
  [8.92415, 45.89222], [8.92732, 45.89171], [8.93155, 45.88581], [8.93377, 45.87033],
  [8.93703, 45.86731], [8.94206, 45.87034], [8.9453, 45.86698], [8.93254, 45.86096],
  [8.91423, 45.84223], [8.91215, 45.83044], [8.92048, 45.8342], [8.92903, 45.83338],
  [8.93297, 45.83901], [8.93909, 45.84127], [8.94881, 45.84343], [8.95315, 45.84232],
  [8.95624, 45.84338], [8.95618, 45.8416], [8.96202, 45.83903], [8.96146, 45.83637],
  [8.96998, 45.83235], [8.97421, 45.83304], [8.97617, 45.83663], [8.98166, 45.83574],
  [8.98667, 45.83852], [8.991, 45.83597], [8.98989, 45.83532], [8.99749, 45.83494],
  [8.99387, 45.82196], [8.99843, 45.82292], [9.00424, 45.82024], [9.01649, 45.81797],
  [9.02237, 45.82192], [9.0314, 45.82084], [9.03446, 45.82302], [9.03093, 45.82469],
  [9.03786, 45.83547], [9.03577, 45.84114], [9.03865, 45.84203], [9.04063, 45.84649],
  [9.04381, 45.84659], [9.0454, 45.84959], [9.05077, 45.85221], [9.04842, 45.85335],
  [9.05183, 45.85443], [9.04916, 45.86261], [9.05151, 45.86723], [9.0537, 45.86799],
  [9.05479, 45.87355], [9.05771, 45.87522], [9.06639, 45.87539], [9.07143, 45.88174],
  [9.07784, 45.88507], [9.07946, 45.88866], [9.07724, 45.89049], [9.07795, 45.89203],
  [9.08164, 45.8918], [9.08515, 45.89596], [9.0888, 45.8969], [9.08745, 45.89931],
  [9.089, 45.90065], [9.08684, 45.90221], [9.07693, 45.8993], [9.07658, 45.91142],
  [9.07264, 45.91284], [9.06781, 45.91063], [9.06819, 45.91291], [9.05906, 45.91648],
  [9.0599, 45.92094], [9.04908, 45.92042], [9.04943, 45.92208], [9.04271, 45.9275],
  [9.02984, 45.9265], [9.02652, 45.9287], [9.01936, 45.92837], [9.02247, 45.93715],
  [9.01977, 45.9397], [9.01357, 45.94151], [9.0122, 45.94378], [9.01712, 45.94901],
  [9.01396, 45.96055], [8.99402, 45.96655], [8.98829, 45.97262], [8.9905, 45.97123],
  [8.99234, 45.97256], [8.99465, 45.97164], [8.99632, 45.97438], [8.99529, 45.98049],
  [9.00735, 45.9803], [9.01115, 45.98318], [9.01136, 45.9879], [9.01322, 45.98876],
  [9.01808, 45.98765], [9.0225, 45.98954], [9.02289, 45.99276], [9.02846, 45.99363],
  [9.02451, 46.00076], [9.02254, 46.01686], [9.00907, 46.02684], [9.00759, 46.0298],
  [9.00952, 46.03729], [9.01689, 46.0431], [9.01743, 46.04998], [9.02301, 46.0528],
  [9.02985, 46.05343], [9.03974, 46.05908], [9.04477, 46.05897], [9.05023, 46.06236],
  [9.06041, 46.06066], [9.07396, 46.06254], [9.0783, 46.06532],
  [9.0725, 46.1181], [9.24842, 46.23377], [9.29936, 46.32754],
  [9.28025, 46.41416], [9.24819, 46.43323], [9.28225, 46.49647], [9.36369, 46.50931],
  [9.41166, 46.46692], [9.46356, 46.50887], [9.46126, 46.37573], [9.54261, 46.30598],
  [9.61869, 46.28736], [9.71451, 46.29292], [9.73693, 46.35092], [9.77687, 46.33482],
  [9.95796, 46.37894], [9.99638, 46.35114], [9.99593, 46.28492], [10.0555, 46.26589],
  [10.04375, 46.22986], [10.07085, 46.21715], [10.17652, 46.25828], [10.1044, 46.33362],
  [10.16194, 46.41451], [10.03915, 46.44698], [10.04389, 46.54047], [10.10235, 46.61074],
  [10.23994, 46.63532], [10.24607, 46.57501], [10.29607, 46.54997], [10.47229, 46.54353],
  [10.49206, 46.61539], [10.40229, 46.63681], [10.38182, 46.68431], [10.44268, 46.75387],
  [10.42272, 46.78824], [10.46651, 46.83586], [10.48808, 46.93874], [10.38462, 46.99997],
  [10.30936, 46.9502], [10.31606, 46.92518], [10.2406, 46.93137], [10.23268, 46.86629],
  [10.10545, 46.84085], [10.01783, 46.90161], [9.87614, 46.93463], [9.87626, 47.02123],
  [9.68185, 47.0621], [9.67984, 47.06221], [9.6725, 47.05968], [9.6644, 47.05983],
  [9.65822, 47.05818], [9.64506, 47.05977], [9.6416, 47.05598], [9.64133, 47.05392],
  [9.63655, 47.0517], [9.63268, 47.05125], [9.62633, 47.05133], [9.62498, 47.05238],
  [9.61721, 47.05362], [9.6072, 47.06071], [9.60348, 47.06177], [9.59977, 47.05897],
  [9.5917, 47.05715], [9.58217, 47.0527], [9.57292, 47.05276], [9.56458, 47.05084],
  [9.55895, 47.04843], [9.55693, 47.04851], [9.55451, 47.0503], [9.55328, 47.05698],
  [9.55163, 47.05884], [9.5489, 47.06101], [9.53976, 47.06515], [9.51655, 47.06009],
  [9.51415, 47.05734], [9.51208, 47.05682], [9.50277, 47.05622], [9.5, 47.05713],
  [9.49954, 47.05415], [9.4974, 47.05416], [9.49333, 47.05651], [9.49132, 47.05625],
  [9.48576, 47.04909], [9.48438, 47.04926], [9.4819, 47.05254], [9.48228, 47.05612],
  [9.4769, 47.0546], [9.47683, 47.05212], [9.47579, 47.05175], [9.47179, 47.06151],
  [9.47239, 47.06503], [9.4751, 47.06697], [9.49228, 47.07384], [9.51354, 47.08563],
  [9.51561, 47.08785], [9.51932, 47.09655], [9.51886, 47.1055], [9.51184, 47.13202],
  [9.50721, 47.14238], [9.49973, 47.14977], [9.49131, 47.16297], [9.48585, 47.18144],
  [9.48976, 47.19649], [9.49961, 47.21128], [9.50165, 47.22017], [9.50465, 47.22512],
  [9.52046, 47.24396], [9.53012, 47.26249], [9.53096, 47.27101], [9.53295, 47.27299],
  [9.54616, 47.28001], [9.55129, 47.28674], [9.55461, 47.29595], [9.55643, 47.29835],
  [9.56559, 47.30412], [9.58161, 47.31116], [9.58815, 47.3174], [9.59946, 47.34512],
  [9.60577, 47.35186], [9.62446, 47.36614], [9.62628, 47.36508], [9.63538, 47.36737],
  [9.65054, 47.36754], [9.66042, 47.37013], [9.67061, 47.37779], [9.67314, 47.38106],
  [9.67385, 47.38387], [9.67409, 47.39015], [9.67246, 47.39262], [9.66009, 47.39754],
  [9.65438, 47.4044], [9.65162, 47.40462], [9.6503, 47.42108], [9.64437, 47.43413],
  [9.64468, 47.43693], [9.6466, 47.43967], [9.65799, 47.44779], [9.65904, 47.44912],
  [9.65898, 47.4522], [9.65537, 47.45404], [9.64568, 47.45565], [9.62238, 47.45746],
  [9.61697, 47.46195], [9.6118, 47.46924], [9.60915, 47.47052], [9.60662, 47.46981],
  [9.60502, 47.46397], [9.60304, 47.46208], [9.60048, 47.46163], [9.59507, 47.46337],
  [9.58187, 47.48307], [9.56564, 47.49245], [9.562, 47.49629], [9.55872, 47.54189],
  [9.4956, 47.55146], [9.39471, 47.62033], [9.25656, 47.65871], [9.21483, 47.6551],
  [9.20304, 47.65533], [9.1871, 47.65745], [9.17597, 47.65399], [9.17549, 47.65577],
  [9.17031, 47.65496], [9.16066, 47.66225], [9.15784, 47.66576], [9.15078, 47.66764],
  [9.13921, 47.66417], [9.11799, 47.6687], [9.10434, 47.67613], [9.0942, 47.67942],
  [9.08803, 47.67992], [9.07589, 47.67862], [9.02338, 47.68685], [9.01486, 47.68532],
  [9.00274, 47.67952], [8.99007, 47.67528], [8.98014, 47.67351], [8.97485, 47.66898],
  [8.94606, 47.6595], [8.94152, 47.65628], [8.92654, 47.65516], [8.92153, 47.65316],
  [8.90691, 47.65056], [8.90178, 47.64854], [8.89384, 47.64834], [8.88355, 47.65394],
  [8.8754, 47.65495], [8.87553, 47.66035], [8.87617, 47.66044], [8.87382, 47.66949],
  [8.87066, 47.6717], [8.86789, 47.67589], [8.86058, 47.68031], [8.85056, 47.68117],
  [8.85165, 47.68248], [8.85054, 47.68263], [8.85109, 47.68559], [8.85276, 47.68588],
  [8.85343, 47.68783], [8.85636, 47.68909], [8.85584, 47.68988], [8.85772, 47.69265],
  [8.85474, 47.69449], [8.85081, 47.69465], [8.85153, 47.69762], [8.85483, 47.69704],
  [8.85808, 47.69874], [8.86017, 47.69816], [8.86062, 47.69626], [8.86322, 47.69843],
  [8.86631, 47.69638], [8.86523, 47.69477], [8.86387, 47.69472], [8.86283, 47.69319],
  [8.86328, 47.6924], [8.86672, 47.69395], [8.8734, 47.69397], [8.87615, 47.69685],
  [8.86969, 47.70187], [8.87274, 47.70407], [8.8666, 47.70547], [8.86103, 47.70413],
  [8.85336, 47.70475], [8.84834, 47.70337], [8.84614, 47.70718], [8.84577, 47.71115],
  [8.84318, 47.71215], [8.83407, 47.7138], [8.83359, 47.71456], [8.83009, 47.71187],
  [8.82553, 47.711], [8.81905, 47.71278], [8.82625, 47.71786], [8.82538, 47.71871],
  [8.81853, 47.71765], [8.81271, 47.72377], [8.80481, 47.72452], [8.80562, 47.7259],
  [8.81086, 47.72821], [8.81155, 47.72929], [8.8109, 47.72974], [8.81218, 47.73042],
  [8.80855, 47.73121], [8.80668, 47.73828], [8.80526, 47.73828], [8.80462, 47.73674],
  [8.79945, 47.73612], [8.79978, 47.7353], [8.79657, 47.73455], [8.7992, 47.72712],
  [8.79182, 47.7288], [8.7907, 47.72725], [8.7887, 47.72776], [8.78661, 47.72634],
  [8.78484, 47.72735], [8.78364, 47.72616], [8.78392, 47.72493], [8.78077, 47.72166],
  [8.77631, 47.72272], [8.77735, 47.72086], [8.7748, 47.71907], [8.77219, 47.71824],
  [8.77014, 47.7191], [8.76976, 47.71845], [8.76996, 47.71602], [8.77098, 47.71603],
  [8.77031, 47.71503], [8.77287, 47.71322], [8.77145, 47.71198], [8.77149, 47.71007],
  [8.76967, 47.70916], [8.76934, 47.70684], [8.78658, 47.70462], [8.79075, 47.70527],
  [8.79397, 47.70424], [8.79759, 47.70285], [8.79857, 47.69894], [8.7976, 47.69721],
  [8.80634, 47.69651], [8.81011, 47.69335], [8.80616, 47.69159], [8.80011, 47.69185],
  [8.79684, 47.68809], [8.79598, 47.68442], [8.79353, 47.6801], [8.79606, 47.67534],
  [8.78834, 47.67554], [8.77448, 47.68084], [8.76759, 47.68569], [8.75778, 47.68938],
  [8.73477, 47.69279], [8.72802, 47.69276], [8.7265, 47.69661], [8.72772, 47.70044],
  [8.7322, 47.71176], [8.73631, 47.71633], [8.73303, 47.71851], [8.72469, 47.72015],
  [8.72483, 47.72128], [8.71794, 47.72162], [8.71116, 47.73014], [8.71461, 47.73859],
  [8.72024, 47.741], [8.72162, 47.74396], [8.72363, 47.74565], [8.72659, 47.74504],
  [8.72805, 47.74614], [8.73954, 47.74652], [8.74144, 47.74818], [8.74114, 47.75198],
  [8.72896, 47.75796], [8.73081, 47.75961], [8.72733, 47.76227], [8.71407, 47.7654],
  [8.70954, 47.76314], [8.70699, 47.76368], [8.70157, 47.76016], [8.70147, 47.76087],
  [8.69911, 47.75961], [8.69734, 47.75663], [8.69593, 47.75681], [8.69513, 47.75571],
  [8.68871, 47.75836], [8.68778, 47.76027], [8.68842, 47.76194], [8.68766, 47.76207],
  [8.68681, 47.76526], [8.68359, 47.7706], [8.68863, 47.77352], [8.68321, 47.7773],
  [8.68332, 47.78049], [8.68176, 47.78294], [8.68237, 47.7837], [8.68005, 47.78526],
  [8.68103, 47.78661], [8.6784, 47.78678], [8.67624, 47.78576], [8.67113, 47.78759],
  [8.66758, 47.7877], [8.66527, 47.79036], [8.66232, 47.79176], [8.65742, 47.79174],
  [8.66, 47.794], [8.66031, 47.79632], [8.65686, 47.80044], [8.6496, 47.79846],
  [8.64892, 47.79499], [8.64693, 47.79471], [8.64575, 47.79071], [8.64546, 47.78722],
  [8.6498, 47.7833], [8.65007, 47.78134], [8.64811, 47.77406], [8.65112, 47.77434],
  [8.65297, 47.7734], [8.64535, 47.76852], [8.64757, 47.76696], [8.64448, 47.7643],
  [8.6424, 47.76521], [8.64057, 47.76434], [8.63167, 47.75819], [8.6277, 47.75939],
  [8.62504, 47.76389], [8.61945, 47.76766], [8.61942, 47.76981], [8.62337, 47.77727],
  [8.61879, 47.77814], [8.61844, 47.78021], [8.61766, 47.78012], [8.61509, 47.78397],
  [8.61577, 47.78714], [8.6205, 47.78894], [8.62215, 47.79486], [8.61791, 47.79604],
  [8.6186, 47.79832], [8.61142, 47.8019], [8.60086, 47.80301], [8.59825, 47.80241],
  [8.59286, 47.79871], [8.58775, 47.80265], [8.5754, 47.7996], [8.57593, 47.80172],
  [8.5731, 47.80607], [8.56888, 47.80723],
];

// Loch: deutsche Enklave Büsingen am Hochrhein (vollständig von CH umschlossen).
// Fein (~60 m) aus geoBoundaries gbOpen CHE/ADM0 abgeleitet (scripts/gen-country-polygon.mjs,
// innerer Ring des Hauptpolygons), damit Punkte knapp innerhalb der Enklave (Ortskern)
// korrekt als DE statt CH klassifiziert werden. Die frühere grobe 27-Punkt-Näherung
// verzeichnete den jagged Enklaven-Rand und ordnete Randpunkte teils falsch zu.
const CH_BUESINGEN_HOLE: number[][] = [
  [8.70129, 47.71519], [8.70464, 47.71343], [8.70893, 47.70414], [8.71181, 47.70174],
  [8.7114, 47.69633], [8.71763, 47.69493], [8.71787, 47.69069], [8.7156, 47.68982],
  [8.70681, 47.68972], [8.69972, 47.69291], [8.69007, 47.69537], [8.67844, 47.68749],
  [8.66964, 47.68484], [8.66341, 47.68578], [8.66405, 47.68815], [8.66124, 47.68873],
  [8.65969, 47.68948], [8.65996, 47.69056], [8.65861, 47.69059], [8.65888, 47.69147],
  [8.66839, 47.69209], [8.66805, 47.69321], [8.67355, 47.69507], [8.67411, 47.69786],
  [8.67631, 47.69755], [8.67358, 47.70489], [8.66602, 47.70786], [8.66466, 47.71336],
  [8.67138, 47.711], [8.67422, 47.71269], [8.67784, 47.71317], [8.68134, 47.71241],
  [8.67993, 47.71056], [8.68384, 47.70873], [8.68633, 47.70857], [8.69032, 47.70945],
  [8.68968, 47.71171], [8.69743, 47.71375], [8.69856, 47.71501], [8.70057, 47.71495],
  [8.70129, 47.71519],
];

// Loch: italienische Enklave Campione d'Italia (vollständig von CH umschlossen).
// Fein (~60 m) aus geoBoundaries gbOpen CHE/ADM0 abgeleitet (scripts/gen-country-polygon.mjs,
// innerer Ring des Hauptpolygons), damit Punkte knapp innerhalb der Enklave (Ortskern,
// Casino) korrekt als IT statt CH klassifiziert werden. Die frühere grobe 7-Punkt-Näherung
// verzeichnete den jagged Enklaven-Rand und ordnete Randpunkte teils falsch zu.
const CH_CAMPIONE_HOLE: number[][] = [
  [8.96708, 45.98415], [8.97742, 45.98288], [8.97633, 45.97586], [8.97717, 45.97195],
  [8.97936, 45.97104], [8.97737, 45.96813], [8.97693, 45.96375], [8.97563, 45.96163],
  [8.97106, 45.96163], [8.9685, 45.96192], [8.96825, 45.96304], [8.95854, 45.96482],
  [8.96415, 45.97616], [8.96488, 45.97982], [8.96708, 45.98415],
];

// Grobes Grenzpolygon Belgiens als [lon, lat]-Ring. Genau genug, um die
// Überlappungen der groben Nachbar-Boxen aufzulösen (Antwerpen würde sonst als
// NL, Arlon/Ardennen als LU erkannt) und BE zuverlässig zu erkennen, ohne
// nennenswert nach NL/LU/FR/DE überzugreifen (Luxemburg-Stadt, Eindhoven,
// Roermond, Maastricht bleiben außerhalb). Annäherung – keine grenzgenaue Geom.
const BE_POLYGON: number[][] = [
  [2.56, 51.08], [2.62, 51.13], [2.88, 51.25], [3.20, 51.36],
  [3.36, 51.37], [4.28, 51.45], [4.76, 51.50], [5.10, 51.31],
  [5.56, 51.22], [5.88, 51.13], [5.78, 51.02], [5.66, 50.92],
  [5.68, 50.78], [6.02, 50.75], [6.40, 50.45], [6.20, 50.13],
  [5.82, 49.55], [5.45, 49.51], [4.85, 49.79], [4.20, 49.96],
  [3.65, 50.34], [3.50, 50.50], [3.30, 50.62], [3.10, 50.75],
  [2.90, 50.82], [2.70, 50.90], [2.56, 51.08],
];

/** Ray-Casting Point-in-Ring. Ring = [[lon,lat], ...]. */
function pointInRing(lon: number, lat: number, ring: number[][]): boolean {
  let inside = false;
  for (let i = 0, k = ring.length - 1; i < ring.length; k = i++) {
    const xi = ring[i][0];
    const yi = ring[i][1];
    const xj = ring[k][0];
    const yj = ring[k][1];
    const intersect =
      yi > lat !== yj > lat && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

/** Polygon = [aussenRing, ...loecher]. */
export function pointInPolygon(lon: number, lat: number, polygon: number[][][]): boolean {
  if (polygon.length === 0 || !pointInRing(lon, lat, polygon[0])) return false;
  for (let h = 1; h < polygon.length; h++) {
    if (pointInRing(lon, lat, polygon[h])) return false; // im Loch -> draußen
  }
  return true;
}

const REFINED_BOUNDARIES: { iso: string; check: (lat: number, lon: number) => boolean }[] = [
  {
    // Belgien als Polygon, BEVOR LU und NL geprüft werden – sonst würde die grobe
    // LU-Box Arlon/die Ardennen als LU und die NL-Heuristik Antwerpen als NL
    // erkennen.
    iso: "BE",
    check: (lat, lon) => pointInPolygon(lon, lat, [BE_POLYGON]),
  },
  {
    iso: "LU",
    check: (lat, lon) => lat >= 49.45 && lat <= 50.18 && lon >= 5.73 && lon <= 6.53,
  },
  {
    // Österreich als Polygon, BEVOR DE und CH geprüft werden – sonst würden die
    // groben DE-/CH-Boxen Grenzregionen (z. B. Salzburg, Vorarlberg) als DE/CH
    // erkennen. Die von DE umschlossene Exklave Jungholz ist NICHT Teil des
    // Haupt-Rings und wird daher separat (zuerst) geprüft.
    iso: "AT",
    check: (lat, lon) =>
      pointInPolygon(lon, lat, [JUNGHOLZ_POLYGON]) ||
      pointInPolygon(lon, lat, [AT_POLYGON]),
  },
  {
    iso: "NL",
    check: (lat, lon) => {
      if (lat < 50.75 || lat > 53.47 || lon < 3.36 || lon > 7.21) return false;
      if (lat >= 51.55) return true;
      if (lat >= 51.0 && lon <= 6.25) return true;
      if (lat >= 50.75 && lon <= 6.05) return true;
      return false;
    },
  },
  {
    // Tschechien als Polygon, BEVOR Deutschland geprüft wird – sonst würde die
    // grobe DE-Box/Heuristik tschechisches Gebiet (z. B. Prag) als DE erkennen.
    iso: "CZ",
    check: (lat, lon) => pointInPolygon(lon, lat, [CZ_POLYGON]),
  },
  {
    // Ostfrankreich als Polygon, BEVOR DE/CH geprüft werden – sonst würden die
    // groben DE-/CH-Boxen Elsass/Lothringen/Franche-Comté als DE bzw. CH erkennen.
    iso: "FR",
    check: (lat, lon) => pointInPolygon(lon, lat, [FR_EAST_POLYGON, GENEVA_HOLE]),
  },
  {
    // Liechtenstein liegt zwischen CH und AT und muss VOR der Schweiz geprüft
    // werden, sonst könnte ein randnaher Punkt vom CH-Polygon erfasst werden.
    iso: "LI",
    check: (lat, lon) => lat >= 47.05 && lat <= 47.27 && lon >= 9.47 && lon <= 9.64,
  },
  {
    // Schweiz als Polygon, BEVOR Deutschland geprüft wird – sonst würde die grobe
    // DE-Heuristik (lat >= 47.55) Schweizer Rheintal-/Bodensee-Orte (Basel,
    // Schaffhausen, Kreuzlingen) als DE erkennen. Die amtliche Geometrie erfasst
    // das Schweizer Ufer korrekt und lässt die deutschen Ufer-/Allgäu-Orte außen,
    // wodurch die früheren zwei manuellen DE-CH-Box-Kompensationsklauseln entfallen.
    iso: "CH",
    check: (lat, lon) =>
      pointInPolygon(lon, lat, [CH_POLYGON, CH_BUESINGEN_HOLE, CH_CAMPIONE_HOLE]),
  },
  {
    iso: "DE",
    check: (lat, lon) => {
      if (lat < 47.27 || lat > 55.06 || lon < 5.87 || lon > 15.04) return false;
      if (lat >= 47.81) return true;
      if (lat >= 47.55 && lon >= 7.5 && lon <= 13.9) return true;
      if (lat >= 47.27 && lon >= 10.2 && lon <= 13.9) return true;
      return false;
    },
  },
];

export function detectCountryFromCoordinates(lat: number, lon: number): string | null {
  for (const refined of REFINED_BOUNDARIES) {
    if (refined.check(lat, lon)) {
      return refined.iso;
    }
  }

  const matches: { iso: string; area: number }[] = [];

  for (const box of COUNTRY_BOUNDING_BOXES) {
    // Österreich wird ausschließlich über das AT_POLYGON (REFINED_BOUNDARIES,
    // oben) bestimmt. Wer diese Schleife erreicht, liegt definitionsgemäß
    // außerhalb des AT-Polygons – die grobe AT-Box würde sonst Nachbarpunkte
    // (z. B. Bozen/Südtirol) fälschlich als AT erkennen, weil sie kleiner als
    // die IT-Box ist.
    if (box.iso === "AT") continue;
    // Belgien wird ausschließlich über das (oben geprüfte) Grenzpolygon erkannt.
    // Die grobe BE-Box ist kleiner als die FR-Box und würde sonst – weil FR kein
    // PRIORITY_COUNTRY ist – nordfranzösische Orte (z. B. Lille) fälschlich als
    // BE greifen, obwohl sie außerhalb des BE-Polygons liegen.
    if (box.iso === "BE") continue;
    // Die Schweiz wird ausschließlich über das CH_POLYGON (REFINED_BOUNDARIES,
    // oben) bestimmt. Die grobe CH-Box (bis lat 47.81, lon 10.49) reicht über den
    // Bodensee bis ins deutsche Allgäu und würde – weil CH ein PRIORITY_COUNTRY ist –
    // deutsche Ufer-/Allgäu-Orte (z. B. Lindau) fälschlich als CH erkennen. Die
    // CH-Box bleibt nur für getCountryBoundingBox/Abdeckung in COUNTRY_BOUNDING_BOXES.
    if (box.iso === "CH") continue;
    if (lat >= box.minLat && lat <= box.maxLat && lon >= box.minLon && lon <= box.maxLon) {
      const area = (box.maxLat - box.minLat) * (box.maxLon - box.minLon);
      matches.push({ iso: box.iso, area });
    }
  }

  if (matches.length === 0) return null;

  for (const prio of PRIORITY_COUNTRIES) {
    if (matches.find((m) => m.iso === prio)) return prio;
  }

  matches.sort((a, b) => a.area - b.area);
  return matches[0].iso;
}

// Die einzige geteilte Quelle dafür, für welche Länder wir EIGENE Geozonen-Daten
// besitzen und daher unsere eigene Karte mit Geozonen-Overlay zeigen. Spiegelt
// exakt Object.keys(COUNTRY_GEOZONE_CONFIGS) aus client/lib/geozones.ts bzw.
// LAYER_GROUPS + ED-269-Vektorländer in web/src/lib/geozoneLayers.ts. Web und
// Mobile leiten ihre "eigene Karte vs. offizielle Staatskarte"-Entscheidung
// gemeinsam hieraus ab, damit beide Plattformen konsistent bleiben.
export const OWN_MAP_DATA_COUNTRIES = ["DE", "FR", "CH", "LU", "NL", "AT", "BE", "DK"];

// True, wenn wir für das Land eigene Geozonen-Daten haben (eigene Karte mit
// Overlay). Sonst wird die offizielle Staatskarte bzw. der EASA-Fallback gezeigt.
export function hasOwnMap(iso?: string | null): boolean {
  if (!iso) return false;
  return OWN_MAP_DATA_COUNTRIES.includes(iso.toUpperCase());
}
